export interface IAdobeDTM {
	trackState: Partial<
		{
			"page.legacyName": string;
			"baseball.gamePk": string;
			"baseball.playerId": string;
			// "page.name": string;
			// "page.type": string;
			// "page.subType": string;
			// "page.viewType": string;
			// "page.viewSubType": string;
		} & unknown &
			Record<string, string | number | Date>
	>;
	trackAction: Partial<
		{
			"action.name": string;
			"action.location": string;
			"action.category": string;
			"action.element.text": string;
			"baseball.playerId": string;
			"baseball.gamePk": string;
			// "action.element.text": string;
			// "action.element.index": number;
			// "action.element.targetUrl": string;
		} & unknown &
			Record<string, string | number | Date>
	>;
}
export abstract class AnalyticService {
	public static trackState(params: IAdobeDTM["trackState"]) {
		console.log("trackState---", params);
		try {
			window._satellite?.track("trackState", params);
		} catch (e) {
			console.log(e);
		}
	}

	public static trackAction(params: IAdobeDTM["trackAction"]) {
		console.log("trackAction---", params);
		try {
			window._satellite?.track("trackAction", params);
		} catch (e) {
			console.log(e);
		}
	}
}
